const HeartCasaideas = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="67"
            height="62"
            viewBox="0 0 67 62"
            fill="none"
            {...props}
        >
            <path
                d="M38.6454 13.1032L36.0954 15.3933C26.3505 2.48116 12.5938 4.77123 9.26427 16.2216C5.62614 28.7114 19.9675 55.3314 27.325 57.0855C34.6824 58.8396 60.7015 38.6513 61.14 20.8829C61.5785 3.11459 44.1838 9.18895 38.6454 13.1032Z"
                fill="#FF8773"
            />
            <path
                d="M64.2421 14.2239C62.0495 8.3607 54.692 5.5509 48.4715 6.73654C43.5131 7.91762 38.9601 10.4016 35.2833 13.9316C34.5181 11.7692 33.3373 9.77745 31.8076 8.06835C25.8307 1.40929 14.429 -0.312324 7.75372 5.64835C1.07842 11.609 1.25708 21.5489 3.31976 30.0108C5.83721 39.8695 19.0254 60.675 25.587 60.675C32.1486 60.675 57.2907 40.4054 62.7803 27.3309C64.5182 23.1243 65.8013 18.4305 64.2421 14.2239Z"
                stroke="#686058"
                strokeWidth="2.51554"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default HeartCasaideas
